import { render, staticRenderFns } from "./ShouninTaskCard.vue?vue&type=template&id=44220c29&scoped=true&"
import script from "./ShouninTaskCard.vue?vue&type=script&lang=ts&"
export * from "./ShouninTaskCard.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninTaskCard.vue?vue&type=style&index=0&id=44220c29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44220c29",
  null
  
)

export default component.exports